module.exports = __webpack_public_path__ + "img/企业文化-banner_02.5b29256e.png";